import { apiFetch } from "@core/http";
import type { Profile } from "@core/types";
import type { ProfileDraft } from "./ProfileForm";

const base = "/v1/portal/security/profiles";

export const listProfiles = () => apiFetch<Profile[]>(base);
export const createProfile = (input: ProfileDraft) =>
  apiFetch<Profile>(base, { method: "POST", body: { ...input, active: true } });
export const editProfile = (id: string, input: ProfileDraft) =>
  apiFetch<Profile>(`${base}/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: input,
  });
// `confirmed` viaja como query string (contrato: 10-catalogs-security.yaml,
// DELETE .../profiles/{id}?confirmed=). La primera llamada nunca la manda
// (equivale a `false`): si el backend responde 409 PROFILE_HAS_USERS, la
// pantalla reintenta con `confirmed: true`.
export const inactivateProfile = (id: string, confirmed: boolean) =>
  apiFetch<void>(
    `${base}/${encodeURIComponent(id)}${confirmed ? "?confirmed=true" : ""}`,
    { method: "DELETE" },
  );
